export var OldPageType;
(function (OldPageType) {
    OldPageType[OldPageType["SEARCH"] = 102] = "SEARCH";
    OldPageType[OldPageType["FORUM"] = 103] = "FORUM";
    OldPageType[OldPageType["CATEGORY"] = 104] = "CATEGORY";
    OldPageType[OldPageType["USER"] = 107] = "USER";
    OldPageType[OldPageType["KB"] = 210] = "KB";
    OldPageType[OldPageType["TICKET"] = 230] = "TICKET";
    OldPageType[OldPageType["SUBMIT_A_TICKET"] = 235] = "SUBMIT_A_TICKET";
    OldPageType[OldPageType["CONTACT"] = 236] = "CONTACT";
    OldPageType[OldPageType["SCHEDULE_A_CALL"] = 237] = "SCHEDULE_A_CALL";
    OldPageType[OldPageType["MAIN"] = 240] = "MAIN";
    OldPageType[OldPageType["TOP_KB_ITEMS"] = 260] = "TOP_KB_ITEMS";
    OldPageType[OldPageType["RESTRICTED"] = 403] = "RESTRICTED";
})(OldPageType || (OldPageType = {}));
export var oldDefaultPlaceholderKeys = {
    COMPANY_NAME: 'COMPANY_NAME',
    COMPANY_LOGO: 'COMPANY_LOGO',
    CANONICAL_URL: 'CANONICAL_URL'
};
export var oldPagePlaceholderKeys = {
    SEARCH: {
        SEARCH_TERM: 'SEARCH_TERM'
    },
    TICKET: {
        TICKET_TITLE: 'TICKET_TITLE',
        TICKET_PREVIEW: 'TICKET_PREVIEW',
        USER_ID: 'USER_ID'
    },
    KB: {
        ARTICLE_TITLE: 'ARTICLE_TITLE',
        ARTICLE_PREVIEW: 'ARTICLE_PREVIEW',
        CATEGORY_TITLE: 'CATEGORY_TITLE',
        PARENT_CATEGORY_TITLE: 'PARENT_CATEGORY_TITLE'
    },
    FORUM: {
        PAGE_NUM: 'PAGE_NUM'
    },
    USER: {
        USER_DISPLAY_NAME: 'USER_DISPLAY_NAME'
    },
    CATEGORY: {
        CATEGORY_TITLE: 'CATEGORY_TITLE',
        PARENT_CATEGORY_TITLE: 'PARENT_CATEGORY_TITLE'
    }
};
//# sourceMappingURL=old-page-type.enum.js.map